<template>
<div>
 <div>
  <b-col class="noPaddingclass mb-3">
    <fieldset class="border border-primary p-2 rounded">
      <legend  class="w-auto px-2 font-weight-bold smaller-font-content text-primary">{{ statetobeprint }}</legend>
      <b-form-group
        :id="`${progID}_carrier_fields`"
        class="container"
        label-for="">
        <div class="credentials row">
         <div class="col-12  mx-auto">
          <div class="alert alert-primary w-70 smallerPaddingAlert .mb-4" role="note" v-show="newStateAdded">
           <div class="row no-gutters">
            <div class="d-inline-block pr-2 my-auto">
              <img width="16px" height="16px" src="../../../assets/info-circle-blue.svg" alt="info">
            </div>
             <div class="col d-inline-block my-auto smaller-font-content" >Save credentials before adding another state.
            </div>
          </div>
        </div>
         <div v-for="(subItem,key) in progCredMapper" :key="key">
          <div class="credential-field" @click="clearErrors(`${subItem.uiField}`)">
            <div>
              <label>{{subItem.uiField}}<span  v-if="subItem.required===true" class='star'>*</span></label>
              <i v-if="subItem.helptext !==undefined" v-b-tooltip.hover :title="`${subItem.helptext}`" placement="bottom" class="fa fa-info-circle tip-icon mt-1" aria-hidden="true"></i>
            </div>
            <div  v-if='(subItem.toggleHideShow)' class="password-field">
            <b-form-input   :id="`${progID}${subItem.uiField}`"
            :name="`${state}${subItem.uiField}`"
            :type="toggleHideShowArr[`${subItem.uiField}`] ? 'password' : 'text'"
            v-model="loginForm[`${subItem.uiField}`]"
            >
          </b-form-input>
            <i @click="toggleHideShowClick(`${subItem.uiField}`)"  style="color:#949494"  :class="(toggleHideShowArr[`${subItem.uiField}`] ? 'fas fa-eye revealer' : 'fas fa-eye-slash revealer')"></i>
          </div>
          <div  v-else-if='(subItem.maskPattern !==undefined)' class="password-field">
           <b-form-input   :id="`${progID}${subItem.uiField}`"
            :name="`${state}${subItem.uiField}`"
            type="text" v-mask="`${subItem.maskPattern}`"
            v-model="loginForm[`${subItem.uiField}`]"
            >
            </b-form-input>
           </div>
            <b-form-input v-else :id="`${progID}${subItem.uiField}`"
            :name="`${state}${subItem.uiField}`"
            type="text"
            v-model="loginForm[`${subItem.uiField}`]"
            ></b-form-input>
            <div>
             <label class="subtext">{{subItem.subtext}}</label>
            </div>
            <div class="errorsection">
              <label class="text-error-msg" :for='`errorFields.${subItem.uiField}Error`' :style="{'visibility':errorFields[`${subItem.uiField}Error`] ? 'visible' : 'hidden'}">{{ errorFields[`${subItem.uiField}Error`] }}</label>
            </div>
          </div>
        </div>
        </div>
        </div>
        <div class="row">
        <div class="credential-field col-6 ">
          <button @click.stop.prevent="validateEntries()" class="btn btn-success">
            <span >Save</span>
          </button>
          </div>
        <div class="credential-field col-6 " v-show="this.permissionRole && this.state != 'AAA'">
             <button @click.stop.prevent="deleteEntries()" class="btn btn-danger float-right" >
              <span >Delete</span>
            </button>
          </div>
         </div>
        </b-form-group>
    </fieldset>
     </b-col>
    </div>
    <modal name="confirm-save-modal" height="auto" :scrollable="true" focusTrap:true >
      <Trap>
        <div class="breakdown-modal-top pt-3 pb-2 pl-3 pr-2 text-white bg-header-auto" >
          <h3 class="breakdown-modal-header">Confirm: Save Login Information</h3>
          <a href="JavaScript:void(0);" @click.prevent="$modal.hide('confirm-save-modal')"
            class="cursorBox fa-stack uniform-icon-breakdown">
            <span class="fas fa-circle fa-stack-2x" style="color:#fff"></span>
            <span class="fas fa-times fa-stack-1x" style="color:#1C3664"></span>
          </a>
        </div>
        <p class="px-3 mt-2 confirm-modal-content mb-4">Saving carrier login credentials will affect the ability to make successful rate calls to this carrier. Please make sure the login credentials are accurate before saving.</p>
          <div class="buttons mb-4">
            <button type="button" id="confirm-cancel-button"
              class="btn btn-primary d-block ml-12 " v-on:click="$modal.hide('confirm-save-modal')">Cancel</button>
            <button type="button" id="confirm-submit-button"
              class="btn btn-primary d-block mr-12" @click.stop.prevent="saveRule()">Save</button>
          </div>
        </Trap>
    </modal>
     <modal :name="`${state}confirm-delete-modal`" height="auto" :scrollable="true" focusTrap:true >
      <Trap>
        <div class="breakdown-modal-top pt-3 pb-2 pl-3 pr-2 text-white bg-header-auto" >
          <h3 class="breakdown-modal-header">Confirm: Delete Login Information</h3>
          <a href="JavaScript:void(0);" @click.prevent="$modal.hide(state+'confirm-delete-modal')"
            class="cursorBox fa-stack uniform-icon-breakdown">
            <span class="fas fa-circle fa-stack-2x" style="color:#fff"></span>
            <span class="fas fa-times fa-stack-1x" style="color:#1C3664"></span>
          </a>
        </div>
        <p class="px-3 mt-2 confirm-modal-content mb-4">Are you sure you would like to delete this state?</p>
          <div class="buttons mb-4">
            <button type="button" id="confirm-cancel-button"
              class="btn btn-primary d-block ml-12 " v-on:click="$modal.hide(state+'confirm-delete-modal')">Cancel</button>
            <button type="button" id="confirm-submit-button"
              class="btn btn-primary d-block mr-12" @click.stop.prevent="deleteRuleModal()">Delete</button>
          </div>
        </Trap>
    </modal>
   </div>
</template>

<script>
/* eslint-disable */
import Trap from 'vue-focus-lock';
import postData from '../../../services/postData';
import { carrierMapper } from '../../../mixins/carrierMapper';
import carrierjson from '../../../../config/credMapper.json';
import stateMapper from '../../../../config/stateMapper.json';
export default {
  props: ['progID','sId','state','permissionRole'],
  mixins: [carrierMapper],
  components:{Trap},
  data() {
    return {
      readJson:carrierjson,
      toggleHideShowArr:{},
      readState:stateMapper,
      flagDefaultLogin:'',
      newStateAdded:true,
      statetobeprint:'',
      stateName: '',
      name: '',
      id: '',
      selected: [], // Must be an array reference!
      progCredMapper: [],
      loginForm:{},
      errorFields:{},
      form: {
        username: '',
        newPassword: '',
       },
      errorFieldstemp: {
        usernameError: '',
        newPasswordError: '',
       },
    };
  },
  computed:{
      masked_input_value: {
      get: function () {
        return this.masked_input;
      },
      set: function (newValue) {
        this.masked_input = newValue;
        this.loginForm.phoneNumber = this.masked_input;
      },
    },
  },
  mounted() {
     this.statetobeprint=this.getStateName(this.state);
     this.getCredMapperForProg();
     this.addloginForm();
    },
  methods: {
     addloginForm() {
      this.progCredMapper.forEach(temp=>{
       let attributeName=temp.uiField;
       this.loginForm[attributeName]='';
       this.$set(this.errorFields, `${attributeName}Error`, '')
       this.$set(this.toggleHideShowArr, `${attributeName}`, 'true')
      });
    },
     getCredMapperForProg(){
      let filterProgData =  this.readJson.filter(el => el.programId == this.progID);
       if(filterProgData.length>0){
         this.progCredMapper=filterProgData[0].fieldMapping;
      }
       else{
         console.log('this carrier need mapper at UI level');
       }
      },
    getStateName(stateCode){
      if(stateCode === null || stateCode === '' || stateCode === 'AAA')
      this.stateName='Default Carrier Login';
      else
      this.stateName=this.readState[stateCode] + " ("+ stateCode + ")";
      return this.stateName;
     },
    toggleHideShowClick(togglefield){
      this.toggleHideShowArr[togglefield]=!this.toggleHideShowArr[togglefield];
     },
    clearErrors(val) {
      // clears the error message property
      this.errorFields[`${val}Error`] = '';
    },
    validateEntries(){
       if (this.validateInputFields()) {
         this.OpenConfirmmodal();
       }
    },
     deleteEntries(){
       this.Opendeletemmodal();
    },
    Opendeletemmodal() {
      this.$modal.show(this.state+'confirm-delete-modal');
      // this.saveRule();
    },
    submitNewCredentials() {
      let objData;
      let filterProgData;
      let formData
      formData=this.loginForm;
      formData.stateCode=this.state;
      let varurl='/programs/'+this.progID+'/publishers/'+this.sId+'/credentials';
        objData=this.mapperCarrier(this.readJson,formData,this.progID);
            const requestParamsCarrierLogin = {
            url:'/programs/'+this.progID+'/publishers/'+this.sId+'/credentials',
            data:objData
          };
          postData.postRuleDashboard(requestParamsCarrierLogin).then((response) => {
          this.form.newPassword = ''
          this.$emit("CredentialUpdateMsg",'true');
          this.newStateAdded=false;
          }).catch((error) => {
          this.$emit("CredentialSaveFailMsg",'true');
          this.form.newPassword = ''
        });
          
    },
    deleteCredentials() {
    //  let varurl='/programs/'+this.progID+'/publishers/'+this.sId+'/credentials/'+this.state;
      let statetoDelete=this.getStateName(this.state);
      if(!this.newStateAdded)
        { const requestParamsCarrierLogin = {
          url:'/programs/'+this.progID+'/publishers/'+this.sId+'/credentials/'+this.state,
        };
         postData.deleteRuleDashboard(requestParamsCarrierLogin).then((response) => {
           this.$emit("deleteStateflag",this.state,statetoDelete,this.newStateAdded);
          }).catch((error) => {
          this.$emit("CredentialSaveFailMsg",'true');
          this.form.newPassword = ''
        });
      }
      else
      {
      this.$emit("deleteStateflag",this.state,statetoDelete,this.newStateAdded);
     }
          
    },
    validateInputFields() {
      let validationFlag = true;
      let errorFieldsKeys = Object.keys(this.errorFields);
      let loginFormKeys = Object.keys(this.loginForm);
      loginFormKeys.forEach((keys) => {
        const matchingObj = this.progCredMapper.find(field => field.uiField === keys);
       if(matchingObj.required && this.loginForm[keys] == '' )
        {
          this.errorFields[`${keys}Error`]='Required.';
        }
       if(matchingObj.totalChar && this.loginForm[keys].length <11 )
        { 
          this.errorFields[`${keys}Error`]='Total digit should be 11.';
        }
       else 
       this.errorFields[`${keys}Error`]='';
      });
      errorFieldsKeys.forEach((keys) => {
       if(this.errorFields[keys]==='Required.')
         validationFlag=false;
       });
       if(validationFlag)
        return true;
       else 
        return false;
    },
    // validateFields() {
    //   this.errorFields.usernameError = this.form.username === '' ? 'Required.' : '';
    //   this.errorFields.newPasswordError = this.form.newPassword === '' ? 'Required.' : '';
    //   if(this.errorFields.usernameError==='Required.' || this.errorFields.newPasswordError==='Required.')
    //   return false
    //   return true;
    // },
    OpenConfirmmodal() {
      this.$modal.show('confirm-save-modal');
    },
    saveRule() {
      this.submitNewCredentials();
      this.$modal.hide('confirm-save-modal');
    },
     deleteRuleModal() {
      this.deleteCredentials();
      this.$modal.hide(this.state+'confirm-delete-modal');
    },
  },
};
</script>

<style scoped>
.noPaddingclass{
  padding-right:0px !important;
  padding-left:0px !important;
}
.buttons {
    display: flex;
    justify-content: space-between;
  }
.credentials .subtext{
  color: #595959;
  font-size: 10px;
}
  P.confirm-modal-content {
    font-weight: 600;
    color: #1A1A1A;
    font-size: 14px;
  }

  #confirm-submit-button,#confirm-submit-button:focus {
    background-color: #2E7B32 !important;;
    color: #fff !important;;
    border-color: #2E7B32 !important;;
  }
.tip-icon {
  color: #949494;
  margin-left:.25rem;
}
  #confirm-submit-button:hover {
    background-color: #fff !important;
    color: #2E7B32 !important;
  }

  #confirm-cancel-button {
    background-color: #fff;
    color: #999;
    border-color: #999;
  }

  #confirm-cancel-button:hover, #confirm-cancel-button:focus,#confirm-cancel-button:focus {
    background-color: #999 !important;
    color: #fff !important;
  }
.breakdown-modal-header {
  display: inline-block;
}

.uniform-icon-breakdown {
  font-size: .7rem;
  float: right;
}
div.breakdown-modal-top h3 {
  font-size: 1rem;
  font-weight: bold;
}

.bg-header-auto {
  background-color: #2D374C !important;
}
.btn{
  text-transform: unset !important;
}
.credentials {
  display: flex;
  align-items: center;
 
}
.errorsection {
  height: 25px;
}
 .credentials LABEL {
    display: inline-flex;
    font-size: 12px;
    font-weight: 600;
  }
.password-field {
  display:-webkit-box;;
  align-items: center;
}
.text-error-msg {
  font-size: 12px;
  color: #BB0000;
  font-weight: 400;
}
.revealer {
  position: relative !important;
  left: -30px !important;
 
}
.ac-carrier-container {
  display:flex;
  align-items:center;
}
img.img-fluid{
  max-width: 180px;
  height: inherit !important;
}
.mr-12
 {
  margin-right: 12rem !important;
}
.ml-12 {
  margin-left: 10rem !important;
}
.smallerPaddingAlert{
    padding-left: 12px; 
    padding-right: 12px;
    padding-top: 8px;
    padding-bottom: 8px;
}
@media (min-width: 1200px) {
  .fieldset-width {
    width: 18%;
  }
}

@media (min-width: 992px) and (max-width: 1199px) {
  .fieldset-width {
    width: 30%;
  }
}

@media (min-width: 768px) and (max-width: 991px) {
  .fieldset-width {
    width: 29.5%;
  }
}

@media (min-width: 576px) and (max-width: 767px) {
  .fieldset-width {
    width: 44%;
  }
}

@media (max-width: 575px) {
  .fieldset-width {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/agencies/carrierLoginUpdater.vue?4f56f0e2